import React from 'react'
import AddHospitalClaimExpense from './AddHospitalClaimExpense'
import AddFuneralClaimExpense from './AddFuneralClaimExpense';
import AddDisabilityClaimExpense from './AddDisabilityClaimExpense';

const AddClaimExpense = (props) => {
  switch (true) {

    case props.hasHospiCashIllnessBenefit:
    case props.hasHospiCashAccidentBenefit:
      return <AddHospitalClaimExpense {...props} />;
    case props.hasFuneralNaturalDeath:
      case props.hasFuneralAccidentalDeath:
      case props.hasAccidentalDeathBenefit:
      case props.hasNaturalDeathBenefit:
      case props.isOldMutualMalawiFuneralClaim:
      case props.isSambaFuneralClaim:
      return <AddFuneralClaimExpense {...props} />;
    case props.hasTotalPermanentDisabilityBenefit:
    case props.hasPartialPermanentDisabilityBenefit:
      return <AddDisabilityClaimExpense {...props} />;

    default:
      return <div>No applicable benefit type found</div>;
  }


}

export default AddClaimExpense